module.exports = __webpack_public_path__ + "static/media/prize4_without_num.603b752f.svg";